import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Actions\Admin\SearchSchedulableCases::__invoke
* @see app/Actions/Admin/SearchSchedulableCases.php:17
* @route '/admin/schedule/search-cases'
*/
export const searchCases = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchCases.url(options),
    method: 'get',
})

searchCases.definition = {
    methods: ["get","head"],
    url: '/admin/schedule/search-cases',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\SearchSchedulableCases::__invoke
* @see app/Actions/Admin/SearchSchedulableCases.php:17
* @route '/admin/schedule/search-cases'
*/
searchCases.url = (options?: RouteQueryOptions) => {
    return searchCases.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\SearchSchedulableCases::__invoke
* @see app/Actions/Admin/SearchSchedulableCases.php:17
* @route '/admin/schedule/search-cases'
*/
searchCases.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchCases.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\SearchSchedulableCases::__invoke
* @see app/Actions/Admin/SearchSchedulableCases.php:17
* @route '/admin/schedule/search-cases'
*/
searchCases.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchCases.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\MoveSchedule::__invoke
* @see app/Actions/Admin/MoveSchedule.php:17
* @route '/admin/schedule/schedules/{schedule}'
*/
export const move = (args: { schedule: number | { id: number } } | [schedule: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: move.url(args, options),
    method: 'patch',
})

move.definition = {
    methods: ["patch"],
    url: '/admin/schedule/schedules/{schedule}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Admin\MoveSchedule::__invoke
* @see app/Actions/Admin/MoveSchedule.php:17
* @route '/admin/schedule/schedules/{schedule}'
*/
move.url = (args: { schedule: number | { id: number } } | [schedule: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { schedule: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { schedule: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: typeof args.schedule === 'object'
        ? args.schedule.id
        : args.schedule,
    }

    return move.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Admin\MoveSchedule::__invoke
* @see app/Actions/Admin/MoveSchedule.php:17
* @route '/admin/schedule/schedules/{schedule}'
*/
move.patch = (args: { schedule: number | { id: number } } | [schedule: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: move.url(args, options),
    method: 'patch',
})

/**
* @see \App\Actions\Admin\RemoveSchedule::__invoke
* @see app/Actions/Admin/RemoveSchedule.php:17
* @route '/admin/schedule/schedules/{schedule}'
*/
export const remove = (args: { schedule: number | { id: number } } | [schedule: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: remove.url(args, options),
    method: 'delete',
})

remove.definition = {
    methods: ["delete"],
    url: '/admin/schedule/schedules/{schedule}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Actions\Admin\RemoveSchedule::__invoke
* @see app/Actions/Admin/RemoveSchedule.php:17
* @route '/admin/schedule/schedules/{schedule}'
*/
remove.url = (args: { schedule: number | { id: number } } | [schedule: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { schedule: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { schedule: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: typeof args.schedule === 'object'
        ? args.schedule.id
        : args.schedule,
    }

    return remove.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Admin\RemoveSchedule::__invoke
* @see app/Actions/Admin/RemoveSchedule.php:17
* @route '/admin/schedule/schedules/{schedule}'
*/
remove.delete = (args: { schedule: number | { id: number } } | [schedule: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: remove.url(args, options),
    method: 'delete',
})

const schedule = {
    searchCases: Object.assign(searchCases, searchCases),
    move: Object.assign(move, move),
    remove: Object.assign(remove, remove),
}

export default schedule